import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { api, CATEGORIES } from "@/lib/api";
import SectionTitle from "@/components/site/SectionTitle";

const fmt = (d) => new Date(d).toLocaleDateString("pl-PL", { day: "numeric", month: "long", year: "numeric" });

export default function NewsSection({ limit, showAll }) {
  const [news, setNews] = useState([]);
  const [open, setOpen] = useState(null);
  useEffect(() => { api.get("/news").then((r) => setNews(r.data)).catch(() => {}); }, []);
  const shown = limit ? news.slice(0, limit + 1) : news;
  const [first, ...rest] = shown;

  return (
    <section id="news" className="relative py-24 md:py-32 px-6 md:px-10 max-w-7xl mx-auto" data-testid="site-news">
      <SectionTitle kicker="Kronika serwera" title="Aktualności" />
      {!news.length && <p className="text-slate-500" data-testid="site-news-empty">Brak wpisów - wkrótce coś się pojawi.</p>}
      {first && (
        <div className="grid lg:grid-cols-5 gap-6">
          <motion.button initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6 }}
            onClick={() => setOpen(first)} data-testid={`site-news-${first.id}`}
            className="lg:col-span-3 text-left steel-panel steel-hover chamfer min-h-[320px] group">
            <div className="steel-inner chamfer relative overflow-hidden p-8 md:p-10 min-h-[317px] flex flex-col justify-end">
            <img src="/assets/koselig-hero.jpg" alt="" className="absolute inset-0 w-full h-full object-cover opacity-30 group-hover:opacity-45 group-hover:scale-105 transition-[opacity,transform] duration-700" />
            <div className="absolute inset-0 bg-gradient-to-t from-[#0a0c1e] via-[#0a0c1e]/75 to-transparent" />
            <div className="relative">
              <span className="text-[11px] tracking-[0.3em] text-tan">{CATEGORIES[first.category]} · {fmt(first.created_at)}</span>
              <h3 className="font-display text-2xl md:text-3xl text-amber-50 mt-3">{first.title}</h3>
              <p className="text-slate-400 mt-3 line-clamp-3">{first.content}</p>
            </div>
            </div>
          </motion.button>
          <div className="lg:col-span-2 flex flex-col gap-4">
            {rest.slice(0, limit ? limit : 8).map((n, i) => (
              <motion.button key={n.id} initial={{ opacity: 0, x: 30 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.08, duration: 0.5 }}
                onClick={() => setOpen(n)} data-testid={`site-news-${n.id}`}
                className="text-left steel-panel steel-hover chamfer" style={{ "--c": "11px" }}>
                <div className="steel-inner chamfer p-5" style={{ "--c": "9.5px" }}>
                <span className="text-[10px] tracking-[0.25em] text-tan">{CATEGORIES[n.category]} · {fmt(n.created_at)}</span>
                <h4 className="text-slate-100 font-semibold mt-1">{n.title}</h4>
                <p className="text-sm text-slate-500 line-clamp-1">{n.content}</p>
                </div>
              </motion.button>
            ))}
          </div>
        </div>
      )}
      {showAll && news.length > 0 && (
        <div className="mt-10 text-center"><Link to="/aktualnosci" className="btn" data-testid="news-all-link">Wszystkie aktualności</Link></div>
      )}
      <Dialog open={!!open} onOpenChange={() => setOpen(null)}>
        <DialogContent className="bg-[#0a0c1e] border-slate-500/40 text-slate-200 max-w-2xl" data-testid="site-news-modal">
          <DialogHeader><DialogTitle className="font-display text-2xl text-slate-100">{open?.title}</DialogTitle></DialogHeader>
          <p className="text-xs text-slate-500">{open && fmt(open.created_at)}</p>
          <p className="whitespace-pre-wrap text-slate-300 leading-relaxed">{open?.content}</p>
        </DialogContent>
      </Dialog>
    </section>
  );
}
